<session-analytic-item-view
  (onExpanded)="onExpanded.emit($event)"
  [isExpanded]="isExpanded"
  title="{{ 'session-analytics_pace-graph' | translate }}"
  [helpDescription]="'session-analytics_pace-help-description' | translate"
  [dataSummary]="'session-analytics_pace-graph-summary' | translate: {averagePace: getAveragePace()}"
  [shouldTease]="shouldTease">
  <div graph
    class="pace-graph-container"
    role="application">
    @if (utterances.length) {
      <highcharts-chart
        #chart
        [options]="chartOptions"
      ></highcharts-chart>
    } @else {
      <analytic-graph-zero-state>
        {{(media.isYoutube() ? 'transcript-viewer-zero-state_youtube-subtext' : 'session-analytics_pace-graph-zero-state') | translate}}
      </analytic-graph-zero-state>
    }

  </div>
</session-analytic-item-view>

